<div *ngFor="let banner of banners;let i = index">
    <div *ngIf="banner" class="banner-wrapper" fxLayout="row">
        <span  class="banner-content">
            {{banner}}
        </span>
        <span class="banner-button-container">
            <button mat-icon-button class="banner-close-button" (click)="banners.splice(i, 1)">
                <mat-icon>close</mat-icon>
            </button>
        </span>
    </div>
</div>



